exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "agm-map {\n  height: 400px;\n}\n\n.noBorder {\n  border: 0px;\n  width: 300px;\n}\n\n.message {\n  font-size: 12px;\n}\n\n@media screen and (max-width: 500px) {\n  .p {\n    font-size: 10px;\n  }\n\n  .label {\n    font-size: 90%;\n  }\n\n  .input {\n    font-size: 90%;\n  }\n\n  .showNotOnMobile {\n    display: none;\n  }\n  .column {\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/add-campervan/add-campervan.component.css
// module id = ../../../../../src/app/components/add-campervan/add-campervan.component.css
// module chunks = main